export default __webpack_public_path__ + "static/media/chain-9.01cdec8d.png";